import { z } from 'zod';
import { nonNegativeNumber, requiredUuidString } from '../zod-helpers/index.js';
import { MAX_STOCK_SETUP_LOCATIONS, PART_CONSTRAINTS } from './constraints.js';
import { checkReorderPointVsOrderUpTo } from './rules.js';
/**
 * The server-side counterpart to `partStockSetupEditFormSchema` — same duplicate-group and
 * reorder-vs-order-up-to rules, over the numeric GraphQL input rather than the form's strings.
 */
export const setPartStockSetupInputSchema = z.object({
    partId: requiredUuidString('Part is required.', 'Invalid part selection.'),
    cycleCountTol: nonNegativeNumber(PART_CONSTRAINTS.cycleCountTol.label)
        .max(PART_CONSTRAINTS.cycleCountTol.max, PART_CONSTRAINTS.cycleCountTol.maxMessage)
        .optional()
        .nullable(),
    locations: z
        .array(z.object({
        locationGroupId: requiredUuidString('Warehouse is required.', 'Invalid warehouse selection.'),
        locationId: requiredUuidString('Location is required.', 'Invalid location selection.'),
        reorderPoint: nonNegativeNumber(PART_CONSTRAINTS.reorderPoint.label).optional().nullable(),
        orderUpToLevel: nonNegativeNumber(PART_CONSTRAINTS.orderUpToLevel.label)
            .optional()
            .nullable(),
    }))
        .max(MAX_STOCK_SETUP_LOCATIONS)
        .superRefine((locations, context) => {
        const seenLocationGroupIds = new Set();
        locations.forEach((location, index) => {
            if (seenLocationGroupIds.has(location.locationGroupId)) {
                context.addIssue({
                    code: 'custom',
                    message: 'Each warehouse can only appear once.',
                    path: [index, 'locationGroupId'],
                });
            }
            seenLocationGroupIds.add(location.locationGroupId);
            const message = checkReorderPointVsOrderUpTo(location.reorderPoint ?? null, location.orderUpToLevel ?? null);
            if (message) {
                context.addIssue({ code: 'custom', message, path: [index, 'reorderPoint'] });
            }
        });
    }),
});
//# sourceMappingURL=set-stock-setup-input.js.map